import React, { useState } from "react";
import CustomerOtpForm from "../../components/CustomerOtpForm";
import SeoHead from "../../components/SeoHead";
import TrustedBusinesses from "../../components/TrustedBusinesses";
import "./login-component.css";

const EMAIL_BENEFITS = [
  "Book and track deliveries from one dashboard",
  "Billing, invoices, and usage in one place",
  "Invite your ops team when you are ready",
];

function LoginComponent({ mode = "signup" }) {
  const isLogin = mode === "login";
  const [step, setStep] = useState("email");

  return (
    <section className="qt-auth">
      <SeoHead
        title={
          isLogin
            ? "Sign in | QikTruck Business Portal"
            : "Create account | QikTruck Business Portal"
        }
        description={
          isLogin
            ? "Sign in to the QikTruck Business Portal with a one-time email code."
            : "Create a QikTruck Business account with a one-time email code. Book, track, and bill deliveries in South Africa."
        }
        pathname={isLogin ? "/login" : "/signup"}
      />
      <div className="qt-auth__inner">
        <div className="qt-auth__form-col">
          <a className="qt-auth__logo" href="/">
            <img
              src="https://media.qiktruck.co.za/qiktruck-new-logo-bg.png"
              alt="QikTruck"
            />
          </a>
          <CustomerOtpForm mode={mode} variant="page" onStepChange={setStep} />
          <a
            className="qt-auth__support"
            href="https://wa.me/27663784460?text=I%20need%20help%20with%20my%20QikTruck%20account"
            target="_blank"
            rel="noreferrer"
          >
            <i className="mdi mdi-whatsapp" aria-hidden="true" />
            Contact support
          </a>
        </div>

        <aside className="qt-auth__aside" aria-label={step === "otp" ? "Next steps" : "Why QikTruck Business"}>
          {step === "otp" ? (
            <>
              <h2 className="qt-auth__aside-title">Check your email, then you are in</h2>
              <p className="qt-auth__aside-copy">
                Use the 6-character code from the message we just sent.
              </p>
              <ol className="qt-auth__steps">
                <li>
                  <span className="qt-auth__step-num" aria-hidden="true">1</span>
                  <div className="qt-auth__step-body">
                    <strong>Open the email</strong>
                    <span>Subject starts with QikTruck Customer Sign In Request.</span>
                  </div>
                </li>
                <li>
                  <span className="qt-auth__step-num" aria-hidden="true">2</span>
                  <div className="qt-auth__step-body">
                    <strong>Enter the code</strong>
                    <span>It auto-submits when all 6 characters are in.</span>
                  </div>
                </li>
                <li>
                  <span className="qt-auth__step-num" aria-hidden="true">3</span>
                  <div className="qt-auth__step-body">
                    <strong>{isLogin ? "Open your dashboard" : "Finish your company profile"}</strong>
                    <span>
                      {isLogin
                        ? "Pick up bookings, billing, and your team from there."
                        : "Then book your first trip from the business dashboard."}
                    </span>
                  </div>
                </li>
              </ol>
            </>
          ) : (
            <>
              <h2 className="qt-auth__aside-title">Trusted by South African businesses</h2>
              <p className="qt-auth__aside-copy">
                Teams use QikTruck Business to book trucks, track drivers, and keep delivery spend in one place.
              </p>
              <TrustedBusinesses variant="dark" showHeading={false} />
              <ul className="qt-auth__benefits">
                {EMAIL_BENEFITS.map((text) => (
                  <li key={text}>
                    <i className="mdi mdi-check" aria-hidden="true" />
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </aside>
      </div>
    </section>
  );
}

export default LoginComponent;
